import { getSvocId, getUserId } from '../utils/utils';

export function getRestartVerificationRequest(channel) {
  return {
    url: `/b2b/user/account/${getUserId()}/customer/${getSvocId()}/militaryDiscount/reset`,
    headers: {
      channelId: channel === 'mobile' ? 2 : 1,
    },
  };
}
